/* eslint-disable no-unused-expressions */
/* Block - Multistep Form.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */

import { elementExists } from '../../js/util/_utilities.js';

// eslint-disable-next-line no-unused-vars
import styles from './block-multistep-form.scss';

/* global hbspt */
jQuery(document).ready(function($) {
    const portalId = '19612709';
    const progressBarClass = '.rs-multistep-form__progress__bar';
    const formContainers = document.querySelectorAll('.rs-multistep-form');

    formContainers.forEach(formContainer => {
        const progressBar = formContainer.querySelector(progressBarClass);
        const target =
            '[data-id=\'' +
            formContainer.getAttribute('data-id') +
            '\'] .multistep-form';
        const data = [];
        const options = [];

        let forms = [];

        if (elementExists(formContainer)) {
            const formsString = formContainer.getAttribute('data-forms');
            if (formsString) {
                forms = formsString.split('||');
            }
        }

        multiStepForm(forms);

        function multiStepForm(forms) {
            if (forms.length > 0) {
                forms.forEach((form, index) => {
                    options.push(generateFormOptions(form, index, target));
                });
            }
            if (options.length > 0) {
                hbspt.forms.create(options[0]);
            }
        }

        function generateFormOptions(form, index, target) {
            return {
                portalId,
                formId: form,
                target,
                onFormReady: function($form) {
                    setProgressBar(index + 1);

                    $form[0].addEventListener('input', () => {
                        updateSubmitStatus($form[0]);
                    });

                    $(target).css(
                        'min-height',
                        $(target)
                            .find('.hs-form')
                            .height(),
                    );
                },
                onFormSubmit: function(form) {
                    formContainer.classList.add('rs-multistep-form--hidden');
                    setTimeout(() => {
                        if (data.length === 0) {
                            const incoming = $(form).serializeArray();
                            data.push(incoming[2]);
                        }
                    }, 500);
                },
                onFormSubmitted: function() {
                    if (index !== forms.length - 1) {
                        $(target).empty();
                        hbspt.forms.create(options[index + 1]);
                        index === 1 ? setTimeout(() => {}, 600) : null;
                    } else {
                        //
                    }
                    formContainer.classList.remove('rs-multistep-form--hidden');

                    $(target).css('min-height', 0);
                },
            };
        }

        //  Update the status of the form submit button (active or inactive).
        function updateSubmitStatus(form) {
            if (formHasData(form)) {
                enableSubmit();
            } else {
                disableSubmit();
            }
        }

        // Check if the form has any data set yet.
        function formHasData(form) {
            const data = $(form).serializeArray();
            let hasData = false;
            if (data.length > 0) {
                data.forEach(element => {
                    if (element.name !== 'hs_context' && element.value) {
                        hasData = true;
                    }
                });
            }
            return hasData;
        }

        // Disable the submit button.
        function disableSubmit() {
            formContainer.classList.add('rs-multistep-form--inactive');
            const button = formContainer.querySelector('.hs-button');
            if (elementExists(button)) {
                button.setAttribute('disabled', 'disabled');
            }
        }

        // Enable the submit button.
        function enableSubmit() {
            formContainer.classList.remove('rs-multistep-form--inactive');
            const button = formContainer.querySelector('.hs-button');
            if (elementExists(button)) {
                button.removeAttribute('disabled');
            }
        }

        //  Set the current width of the status bar.
        function setProgressBar(index) {
            const progress = (index / forms.length) * 100;
            if (elementExists(progressBar)) {
                progressBar.style.width = progress + '%';
            }
        }
    });
});
